import { Routes, Route } from 'react-router-dom';
import { Login, Dashboard, Users, Roles, FormRoles, Blogs, Reviews, Pixels, FormBlogs, NotFoundPage, FormUsers, Settings, Categories, Brands, Orders, Products, Contacts } from '../pages';
import { MainLayout } from '../layout';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import ContentStudioPage from '../Content/pages/ContentStudioPage';


const Routers = () => {
  return (
    <div>
      <Routes>
        {/* <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </ProtectedRoute>
          }
        /> */}
        {/* **************************************Roles*Start******************************************* */}
        <Route
          path="/Roles"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Roles />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Roles/New"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FormRoles />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Roles/update/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FormRoles />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        {/* **************************************Roles*End******************************************* */}

        {/* **************************************Users*Start******************************************* */}

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Users />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/users/New"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FormUsers />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/update/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FormUsers />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* **************************************Users*End******************************************* */}

        {/* **************************************Blogs*Start******************************************* */}

        <Route
          path="/blogs"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Blogs />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/blogs/New"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FormBlogs />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/blogs/update/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FormBlogs />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* **************************************Blogs*End******************************************* */}

        <Route
          path="/Categories"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Categories />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Brands"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Brands />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Pixels"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Pixels />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reviews"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Reviews />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Contacts"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Contacts />
              </MainLayout>
            </ProtectedRoute>
          }
        />



        <Route
          path="/Settings"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Settings />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Orders"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Orders />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Products />
              </MainLayout>
            </ProtectedRoute>
          }
        />


        <Route path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
        <Route path="*" element={<NotFoundPage />} />














        {/* **************************************Content*Start******************************************* */}
        <Route
          path="/content"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ContentStudioPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />


        {/* **************************************Content*End******************************************* */}

      </Routes>
    </div>
  );
};

export default Routers;
